export default __webpack_public_path__ + "message.31135383b3efe4ce.svg";